import * as Yup from 'yup';

const contributionSchema = Yup.object().shape({
  type: Yup.string().oneOf(['percent', 'amount']).required(),
  value: Yup.number().when('type', ([type], schema: Yup.NumberSchema) => {
    return type === 'percent' ? schema.max(100, 'Percent must be less than 100%') : schema;
  }),
});

const bonusSchema = Yup.lazy(value =>
  value == null
    ? Yup.mixed().notRequired()
    : Yup.object({
        traditional: contributionSchema.notRequired(),
        roth: contributionSchema.notRequired(),
      }).test('bonus-total-percent', 'Total percent must be less than 100%', contributions => {
        const { traditional, roth } = contributions;
        if (
          traditional?.type === 'percent' &&
          roth?.type === 'percent' &&
          traditional.value !== undefined &&
          roth.value !== undefined
        ) {
          return traditional.value + roth.value <= 100;
        }
        return true;
      })
);

export const validationSchema = Yup.object({
  base: Yup.object({
    traditional: contributionSchema.required(),
    roth: contributionSchema.notRequired().default(undefined),
  })
    .required()
    .test('base-total-percent', 'Total percent must be less than 100%', contributions => {
      const { traditional, roth } = contributions;
      if (
        traditional?.type === 'percent' &&
        roth?.type === 'percent' &&
        traditional.value !== undefined &&
        roth.value !== undefined
      ) {
        return traditional.value + roth.value <= 100;
      }
      return true;
    }),
  bonus: bonusSchema,
});
